import type { Contact } from './types'

let _contacts: Contact[] = []

export function setContacts(contacts: Contact[]) {
  _contacts = contacts
}

export function contactById(contacts: Contact[] | undefined, id: string): Contact | undefined {
  return (contacts ?? _contacts).find((c) => c.id === id)
}
